import { useNavigationStore } from '@/stores/navigation'

export default function GlobalImpactPartnershipsSection() {
  const { openPartnershipModal } = useNavigationStore()

  const handlePartnershipClick = () => {
    openPartnershipModal()
  }

  const handleReferralClick = () => {
    openPartnershipModal()
  }

  return (
    <section id="partners" className="relative overflow-hidden">
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-white via-slate-50 to-white"/>

      <div className="mx-auto max-w-7xl px-6 py-12 lg:py-14">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900">Global Impact & Partnerships</h2>
          <p className="mt-2 text-slate-600">
            We are a leading, global provider of collaborative healthcare solutions. Using the Eceptionist suite, organizations coordinate care across
            departments, sites, communities, ACOs, and countries—delivering better care, more efficiently.
          </p>
        </div>

        {/* Program Cards */}
        <div className="mt-8 grid gap-6 lg:grid-cols-2">
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-xl font-semibold text-slate-900">Global Partnerships</h3>
            <p className="mt-2 text-slate-600">
              We collaborate with partners worldwide. Some are also customers; others sell, implement, or consult to add value to the Eceptionist platform.
            </p>
            <div className="mt-4">
              <button
                onClick={handlePartnershipClick}
                className="inline-flex items-center justify-center rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white shadow hover:shadow-md transition"
              >
                Become a Partner
              </button>
            </div>
          </div>

          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <h3 className="text-xl font-semibold text-slate-900">Referral & Reseller Program</h3>
            <p className="mt-2 text-slate-600">
              Organizations and individuals can participate in our referral program. If you're interested in reselling Eceptionist services, we'd love to talk.
            </p>
            <div className="mt-4">
              <button
                onClick={handleReferralClick}
                className="inline-flex items-center justify-center rounded-xl bg-emerald-600 px-4 py-2 text-sm font-semibold text-white shadow hover:shadow-md transition"
              >
                Join the Program
              </button>
            </div>
          </div>
        </div>
  
          {/* Partners — responsive: grid on desktop, horizontal scroll on mobile */}
          <div className="mt-10">
            <p className="text-center text-sm font-semibold uppercase tracking-wider text-slate-600">Selected Partners</p>
  
            {/* Desktop grid */}
            <div className="mt-6 hidden md:flex flex-wrap justify-center gap-4">
              {['Telus Health','Public Consulting Group (PCG)','CellServe','Insight','MEC'].map((name) => (
                <div key={name} className="flex h-16 items-center justify-center rounded-xl border border-slate-200 bg-gradient-to-br from-emerald-50 via-white to-sky-50 backdrop-blur shadow-sm px-4">
                  <span className="text-base font-semibold text-slate-700 text-center px-2">{name}</span>
                </div>
              ))}
            </div>
  
            {/* Mobile horizontal scroll */}
            <div className="mt-6 md:hidden overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none]">
              <div className="flex min-w-full snap-x snap-mandatory gap-3 pr-3">
                {['Telus Health','Public Consulting Group (PCG)','CellServe','Insight','MEC'].map((name) => (
                  <div key={name} className="snap-start shrink-0 w-56 h-16 flex items-center justify-center rounded-xl border border-slate-200 bg-gradient-to-br from-emerald-50 via-white to-sky-50 backdrop-blur shadow-sm">
                    <span className="text-base font-semibold text-slate-700 text-center px-3">{name}</span>
                  </div>
                ))}
              </div>
            </div>
  
            <p className="mt-6 text-center text-sm text-slate-600">
              Interested? <a href="mailto:info@eceptionist.com" className="font-semibold text-slate-900 underline-offset-2 hover:underline">info@eceptionist.com</a>
            </p>
          </div>
        </div>
      </section>
    );
  }
  